<template>
  <el-select
    filterable
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option label="全国" value="0"></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'filter-region-nation',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },
}
</script>
